import { render, staticRenderFns } from "./ItemContextMenu.vue?vue&type=template&id=45e2fb35&"
import script from "./ItemContextMenu.vue?vue&type=script&lang=js&"
export * from "./ItemContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./ItemContextMenu.vue?vue&type=style&index=0&id=45e2fb35&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports